<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <form @submit.prevent="addOccupation">
        <div class="space-y-4">
          <div>
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Occupation Name</label>
            <input
              type="text"
              v-model="form.name"
              placeholder="Occupation Name"
              class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
              required
            />
          </div>
          <div class="flex justify-end">
            <button
              type="submit"
              :disabled="spinner"
              class="btn-primary"
            >
              <i class="fa-solid fa-save"></i>
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";

interface OccupationForm {
  name: string | null;
}

const store = useConfigurationsStore();
const spinner = ref(false);
const form = ref<OccupationForm>({
  name: null
});

const addOccupation = () => {
  if (!form.value.name) {
    return;
  }

  spinner.value = true;
  store.createOccupation(form.value);
};

watch(
  () => store.occupation,
  (occupation) => {
    if (occupation) {
      // @ts-ignore - successToast is injected globally
      window.successToast("Success", "Occupation created successfully");
      spinner.value = false;
      form.value = { name: null };
      store.fetchOccupations();
    }
  }
);

watch(
  () => store.error,
  (error) => {
    if (error) {
      spinner.value = false;
      // @ts-ignore - errorToast is injected globally
      window.errorToast("Error", "Occupation creation failed");
    }
  }
);
</script>

